import { render } from "./Main.vue?vue&type=template&id=d6a2d796&scoped=true&ts=true"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"

import "./Main.vue?vue&type=style&index=0&id=d6a2d796&lang=less&scoped=true"

import exportComponent from "D:\\phpStudy_pro\\WWW\\drchat-v2\\front-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6a2d796"]])

export default __exports__